module.exports = __webpack_public_path__ + "static/media/refresh.c76666e2.svg";